const model = { t: 'Model', name: 'model', hint: { url: '/model/motorcycle', deps: ['marka'], cache: 'moto-model', exact: true, isDepFor: ['generacja'] }}
export default model